import { Injector } from '@angular/core';
import { LoaderService } from '../../support/loading/loader.service';

export class ActiveModalLoader {

    public loader;

    constructor(injector: Injector) {
        const loaderService = injector.get(LoaderService);

        this.loader = loaderService.create();
    }

    public start() {
        this.loader.start();
    }

    public stop() {
        this.loader.stop();
    }

    public isLoading() {
        return this.loader.isLoading();
    }

    public loading() {
        return this.loader.isLoading();
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/modals/classes/active-modal-loader.ts